import svgpaths from '../data/svgpaths.json'

    const svgpath = (iconName, index) => { return Object.values(svgpaths[iconName])[index]}

export default svgpath  